import * as tslib_1 from "tslib";
import { OnInit } from '@angular/core';
import { NavigationEnd } from '@angular/router';
import { Subject } from 'rxjs';
export class PlantingSiteListComponent {
    constructor(route, siteService, router, appConfigService) {
        this.route = route;
        this.siteService = siteService;
        this.router = router;
        this.appConfigService = appConfigService;
        this.unfilteredSites = [];
        this.pageSizeUpdate$ = new Subject();
        this.unfilteredSitesChanged$ = new Subject();
    }
    ngOnInit() {
        this.pageSize = this.appConfigService.plantingSiteListPageSize;
        this.route.data.subscribe(data => {
            this.unfilteredSites = data.plantingSites || [];
        });
        this.router.events.subscribe((evt) => {
            if (!(evt instanceof NavigationEnd)) {
                return;
            }
            window.scrollTo(0, 0);
        });
    }
    updatePageSize(pageSize) {
        this.pageSize = pageSize;
        this.appConfigService.updatePlantingSitePageSize(pageSize);
        this.pageSizeUpdate$.next(pageSize);
    }
    siteDeleted(site) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            yield this.siteService.deletePlantingSite(site.id);
            this.unfilteredSitesChanged$.next(yield this.siteService.getAll());
        });
    }
}
